'use strict';

function columnName (column) {
  return column.replace('[', '').replace(']', '');
}

module.exports = columnName;



//////////////////
// WEBPACK FOOTER
// ./~/turbo-carto/src/helper/column-name.js
// module id = 1079
// module chunks = 6